import { render, staticRenderFns } from "./CoreIdea.vue?vue&type=template&id=e51a9822"
import script from "./CoreIdea.vue?vue&type=script&lang=js"
export * from "./CoreIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports